import React, { useRef } from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';
import { enumUtil } from '../../../../../utils/Enum';
import { useState, useEffect } from 'react';
import isNull from '../../../../../utils/NullChecking';
import FormValidator from '../../../../../utils/FormValidator';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import { GetZipCode, ServerRequestProtected, ServerRequestPublic } from '../../../../../utils/ServerDataRequest';
import States, { CoveragePriority, Relationship, ServiceTypeCode, SexualOrientation } from '../../../../../utils/Constants';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Loader from '../../../../shared/Loader/Loader'
import Nav from 'react-bootstrap/Nav';
import { NavItem, NavLink } from 'reactstrap';
import { Gender, Status } from '../../../../../utils/Constants';
import format from 'date-fns/format';
import SuperSearchList from '../../../../shared/SuperSearch/SuperSearchList';
import { MenuItem, Select } from "@mui/material"
import FormatDate from '../../../../shared/DateFormatter';
import handleNumericCheck from '../../../../../utils/HandleNumericKeys';
import AddNewInsurance from '../../../../Setup/InsuranceM/Insurance/AddNewInsurance';
import DropdownValueHandler from '../../../../shared/SuperSearch/DropdownValueHandler';
import DatePicker from '../../../../General/DatePicker';
import { Modal } from 'react-bootstrap';
import EligiblityHistoryStatus from '../../../../Billing/Realtime/RealtimeDetails/Eligibility History/History/EligiblityHistoryStatus';
import HandleValidationError from '../../../../HandleValidationError/HandleValidationError';
import { saveAs } from "file-saver"
import handleDecimalCheck from '../../../../../utils/handleDecimalCheck';
import { FindFirstChild } from '../../../../../utils/FindMenuOption';
import Audit from '../../../../General/Audit';
import SubscriberUpdatePopup from './SubscriberUpdatePopup';
import AutoSelectDropDownValue from '../../../../shared/AutoSelectDropDownValue';
import DeleteConfirmatiom from '../../../../General/DeleteConfirmation';
import AddNewEmployer from '../../../../Setup/Account/Empolyer/AddNewEmployer';
import AddnewLawyer from '../../../../Setup/Account/Lawyer/AddnewLawyer'
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import _ from "lodash";
import { GeneralDropDowns } from '../../../../../actions/GeneralPatientActions';
import { useDispatch } from 'react-redux';
import { useKeyboardShortcut } from '../../../../../utils/useKeyboardShortcut';
import MergeInsuranceForm from '../../../../shared/MergeIntakeForms/MergeInsuranceForm';
import { IconDownload } from '../../../../shared/IconsComponent/icons';


const PlanIformation = (props) => {
    const isFirstRun = useRef(true);
    const [modalActive, setModalActive] = useState(false)
    let IsEditAllowed = FindFirstChild('Patient', 'Insurance/Plan info')?.IsAdd
    let IsDeleteAllowed = FindFirstChild('Patient', 'Insurance/Plan info')?.IsDeleted
    let PerformEligibilityAllowed = FindFirstChild('Patient', 'Eligibility')?.IsAdd
    const isLive = process.env.REACT_APP_ISLIVE
    const PracticeID = useSelector(state => state?.GeneralDropDownsReducer?.Practice?.[0]?.PracticeID || null);
    let PatientPortalAccessRedux = useSelector(state => state.SettingsReducer?.PatientPortalAccess);

    const API_URL = enumUtil.controller.PATIENT
    const API_URL_Wasabi = enumUtil.controller.Wasabi
    const API_URL_Eligibility = enumUtil.controller.Eligibility
    const API_URL_GENERAL = enumUtil.controller.General
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    let InsurancePlan_Modal = {
        PatientInsuranceID: "",
        PatientID: "",
        InsuranceID: "",
        InsuranceName: "",
        CoveragePriority: "",
        MedicareSecPlanType: "",
        RelationShipCode: "",
        LastName: "",
        FirstName: "",
        MI: "",
        Gender: "",
        DOB: null,
        SSN: "",
        AddressLine1: "",
        AddressLine2: "",
        LawyerID: '',
        City: "",
        State: "",
        ZipCode: "",
        GroupName: "",
        GroupNumber: "",
        EffectiveFrom: null,
        AccidentDate: null,
        LastSeenDate: null,
        AccidentType: '',
        AccidentState: '',
        WCCase: '',
        EffectiveTo: null,
        PatientInsuranceAddress: '',
        Copay: "",
        TotalDeductible: "",
        RemainingDeductible: "",
        CoInsurance: "",
        SubscriberID: "",
        ShortName: "",
        AcceptAssignment: "",
        Hospice: false,
        AccidentIllnesInfoInClaim: false,
        PayerID: "",
        InsuranceAddress1: "",
        InsuranceAddress2: "",
        InsuranceCity: "",
        InsuranceState: "",
        InsuranceZipCode: "",
        FileFrontSide: "",
        FileBackSide: "",
        FileFrontPath: "",
        FileBackPath: "",
        FileFrontSideView: "",
        FileBackSideView: "",
        EmployerID: "",
        Comment: "",
        FileNameFront: "",
        FileNameBack: "",
        Statuss: "",
        instAdd1: "",
        instAdd2: "",
        instCity: "",
        instState: "",
        instZipCode: "",
        ErrorMessages: '',
        UpdatedBy: '',
        UpdatedDate: '',
        CreatedBy: '',
        CreatedDate: ''
    }
    let valModal = {}
    let ValidationModal = {
        LastNameVal: "",
        FirstNameVal: "",
        InsuranceNameVal: "",
        CoveragePriorityVal: "",
        ZipCodelengthVal: "",
        ShortNameVal: "",
        SubscriberIDVal: "",
        SubscriberILengthDVal: "",
        MIVal: "",
        SSNLengthVal: "",
        SSNVal: "",
        ZipCodeVal: "",
        RelationShipCodeVal: "",
        SubscriberID: "",
    }
    let ValModalEligibility = {}
    let ValidationModalEligibility = {
        PatientInsuranceIDval: '',
    }
    const Eligibility_Modal = {
        PatientInsuranceID: '',
        ProviderID: '',
        ServiceTypeCode: '',
        UsePracticeNPI: true
    }
    const [PatientID, setPatientID] = useState()
    let PateintIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    PateintIDR = PateintIDR?.data?.id
    const SecPlanTypeDD = [
        { value: "", display: "" },
        { value: 12, display: "Working Aged Beneficiary or Spouse with Employer Group Health Plan" },
        { value: 13, display: "End-Stage Renal Disease Beneficiary in the Mandated Coordination Period" },
        { value: 14, display: "No-fault Insurance including Auto is Primary" },
        { value: 15, display: "Worker’s Compensation" },
        { value: 16, display: "Public Health Service (PHS)or Other Federal Agency" },
        { value: 41, display: "Black Lung" },
        { value: 42, display: "Veteran’s Administration" },
        { value: 43, display: "Disabled Beneficiary Under Age 65 with Large Group Health Plan (LGHP)" },
        { value: 47, display: "Other Liability Insurance is Primary" },
    ]

    let DefaultIsPicsUpdate = { FrontPic: false, BackPic: false }
    const [InsuranceListModal, setInsuranceListModal] = useState([]);
    const [mainInsurancePlanModal, setmainInsurancePlanModal] = useState(InsurancePlan_Modal);
    const [InsurancePlanSaveUpdateModal, setInsurancePlanSaveUpdateModal] = useState({})
    const [InsurancePlanValidationModal, setInsurancePlanValidationModal] = useState(ValidationModal)
    const [isLoading, setIsLoading] = useState(false)
    const [PatientInsuranceID, setPatientInsuranceID] = useState("0");
    const [PatientInsuranceTemplateDataID, setPatientInsuranceTemplateDataID] = useState();
    const [activeTab, setActiveTab] = useState()
    const [insurancDetails, setInsuranceDetails] = useState('');
    const [createPlan, setCreatePlan] = useState(false)
    const [bgBlur, setBgBlur] = useState(false);
    const [isSelfPay, setIsSelfPay] = useState(false);
    const [isSelfPayChanged, setisSelfPayChanged] = useState(false)
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [claimsCount, setClaimsCount] = useState(0);
    const [SbrClaimsCount, setSbrClaimsCount] = useState(0);
    const [InsClaimsCount, setInsClaimsCount] = useState(0);
    const [showLivePre, setShowLivePre] = useState(false);
    const [is, setIs] = useState(false);
    const [insuranceBody, setinsuranceBody] = useState({
        "TableName": enumUtil.enumAPITableName.Insurance,
        "SearchParam": '',
    });
    const [IsOpenInsurance, setIsOpenInsurance] = useState(false);
    const [InsuranceID, setInsuranceID] = useState(0);
    const [isSaved, setisSaved] = useState(false)
    const [isPateintImageSaved, setisPateintImageSaved] = useState(DefaultIsPicsUpdate);
    const [isUpdated, setisisUpdated] = useState(false)
    const [isUpdatedID, setisisUpdatedID] = useState('')
    const [EligibilityPopup, setEligibilityPopup] = useState(false);
    const [EligibilityID, setEligibilityID] = useState();
    const [updateAlertPopup, setUpdateAlertPopup] = useState(false);
    const [updatesubscriberID, setupdatesubscriberID] = useState(false);
    const [updateInsuranceID, setUpdateInsuranceID] = useState(false);
    const [isIDsUpdated, setIsIDsUpdated] = useState({ SbrIDUpdated: false, InsIDUpdated: false })
    const [NewSubscriberID, setNewSubscriberID] = useState(null)
    const [NewInsuranceID, setNewInsuranceID] = useState(null)
    const [NewInsuranceName, setNewInsuranceName] = useState(null)
    const [EligibilityBody, setEligibilityBody] = useState(false);
    const [mainEligibilityModal, setmainEligibilityModal] = useState(Eligibility_Modal);
    const [EligibilitySaveUpdate, setEligibilitySaveUpdate] = useState({})
    const [EligibilityValidationModal, setEligibilityValidationModal] = useState(ValidationModalEligibility)
    const [message, setMessage] = useState('');
    const [performEligibilityData, setPerformClaimStatusData] = useState();
    const [errorPopup, setErrorPopup] = useState(<></>);
    const [isOpenMissing, setIsOpenMissing] = useState(false)
    const [missingData, setMissingData] = useState(false)
    const [missingDataInfo, setMissingDataInfo] = useState([]);
    const [previousSubscriberID, setpreviousSubscriberID] = useState('');
    const [previousInsuranceID, setpreviousInsuranceID] = useState('');
    const [previousInsuranceName, setpreviousInsuranceName] = useState('');
    const [ClaimFor, setClaimFor] = useState('BOTH');
    const [isOpenSubscriber, setisOpenSubscriber] = useState(false);
    const [showAllInsurances, setShowAllInsurances] = useState(false)
    const [AllInsurances, setAllInsurances] = useState([])
    const [addressDropdown, setAddressDropdown] = useState([])
    const [employerDropdown, setEmployerDropDown] = useState([])
    const [lawyerDropdown, setLawyerDropDown] = useState([])

    const handleInsurranceDetails = async () => {
        if (PateintIDR != -1) {
            setShowAllInsurances(false)
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindPatientInsuranceDetails", 'post', {
                "ID": PateintIDR,
                "TableName": enumUtil.enumAPITableName.PatientInsurance
            }).then(async (response) => {
                setIsLoading(false)
                setIs(true)
                let allInsu = response
                setAllInsurances(allInsu)
                let data = [...response]
                data = data.filter(item => item.STATUS === true)
                setInsuranceListModal(data)
                if (data.length > 0) {
                    let leng = data.length - 1
                    if (isSaved === true) {
                        setActiveTab(data[leng].PatientInsuranceID)
                        handleActivePlan(data[leng].PatientInsuranceID)
                    } else {
                        setActiveTab(data[0].PatientInsuranceID)
                        handleActivePlan(data[0].PatientInsuranceID)
                    }
                    ServiceTypeCode.map((item) => {
                        if (item.value === '30') {
                            EligibilitySaveUpdate.ServiceTypeCode = item.value
                            mainEligibilityModal.ServiceTypeCode = item.display
                        }
                    })
                    EligibilitySaveUpdate.PatientInsuranceID = data[0].PatientInsuranceID + ""
                    mainEligibilityModal.PatientInsuranceID = data[0].InsuranceName
                } else {
                    setPatientInsuranceID('0')
                    setmainInsurancePlanModal(InsurancePlan_Modal)
                    setInsurancePlanSaveUpdateModal({})
                }

                setisisUpdated(false)
                // setisSaved(false)
            }).catch((error) => {
                setAllInsurances([])
                setInsuranceListModal([])
                setIsLoading(false)
            })
        } else {
            NotificationHandler("Please Fill Demographics First", enumUtil.enumtoaster.warning);
        }
    }
    const handleFindBy = async () => {
        setmainInsurancePlanModal(InsurancePlan_Modal)
        if (PatientInsuranceID !== '0') {
            setIs(true)
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID ", 'post', {
                "ID": PatientInsuranceID,
                "TableName": enumUtil.enumAPITableName.PatientInsurance
            }).then((response) => {
                if (!updateAlertPopup) {
                    setpreviousSubscriberID(response?.SubscriberID);
                    setSbrClaimsCount(response?.SBRClaimCount);
                    setClaimsCount(response?.CommanClaimCount);
                    setpreviousInsuranceID(response?.InsuranceID);
                    setpreviousInsuranceName(response?.ShortName)
                    setInsClaimsCount(response?.InsuranceClaimCount);
                }
                let data = [...InsuranceListModal]
                if (createPlan === true) {
                    let filtereddata = data.filter((item) => item.PatientInsuranceID !== '-1')
                    setInsuranceListModal(filtereddata)
                    setCreatePlan(false)
                }
                if (!isNull(response.ProviderID)) {
                    mainEligibilityModal.ProviderID = DropdownValueHandler(DropDowns?.Provider, response.ProviderID)
                    EligibilitySaveUpdate.ProviderID = response.ProviderID + ""
                } else {
                    mainEligibilityModal.ProviderID = AutoSelectDropDownValue(DropDowns?.Provider).display
                    EligibilitySaveUpdate.ProviderID = AutoSelectDropDownValue(DropDowns?.Provider).value + ""
                }
                setInsuranceID(response.InsuranceID + "")
                handleDropDownApi(response.InsuranceID + "")
                EmplyerDropdown()
                setIsLoading(false)
                setIs(true)

                setisPateintImageSaved((prev) => {
                    return {
                        FrontPic: (response.FileFrontExist === 'true' ? true : false),
                        BackPic: (response.FileBackExist === 'true' ? true : false)
                    }
                })

                if (!isNull(response.ProviderID)) {
                    EligibilitySaveUpdate.ProviderID = response.ProviderID + ""
                }
                response.State = DropdownValueHandler(States, response.State)
                response.AccidentState = DropdownValueHandler(States, response.AccidentState)
                response.EmployerID = DropdownValueHandler(DropDowns?.Employer, response.EmployerID)
                response.LawyerID = DropdownValueHandler(DropDowns?.Lawyer, response.LawyerID)
                response.MedicareSecPlanType = DropdownValueHandler(SecPlanTypeDD, response.MedicareSecPlanType)
                response.PlanState = DropdownValueHandler(States, response.PlanState)
                response.CoveragePriority = DropdownValueHandler(CoveragePriority, response.CoveragePriority)
                response.RelationShipCode = DropdownValueHandler(Relationship, response.RelationShipCode)
                response.Gender = DropdownValueHandler(Gender, response.Gender)
                if (!isNull(response.ErrorMessages)) {
                    let splitedData = response.ErrorMessages.split(';')
                    setMissingDataInfo(splitedData)
                }
                setmainInsurancePlanModal({
                    ...response, EffectiveFrom: !isNull(response.EffectiveFrom) ? FormatDate(response.EffectiveFrom) : null,
                    DOB: !isNull(response.DOB) ? FormatDate(response.DOB) : null,
                    EffectiveTo: !isNull(response.EffectiveTo) ? FormatDate(response.EffectiveTo) : null,
                    instAdd1: response.InsuranceAddress1,
                    instAdd2: response.InsuranceAddress2,
                    instCity: response.InsuranceCity,
                    instState: response.InsuranceState,
                    instZipCode: response.InsuranceZipCode,
                    PayerID: response.PayerID
                })
                setInitialState({
                    ...response, EffectiveFrom: !isNull(response.EffectiveFrom) ? FormatDate(response.EffectiveFrom) : null,
                    DOB: !isNull(response.DOB) ? FormatDate(response.DOB) : null,
                    EffectiveTo: !isNull(response.EffectiveTo) ? FormatDate(response.EffectiveTo) : null,
                    instAdd1: response.InsuranceAddress1,
                    instAdd2: response.InsuranceAddress2,
                    instCity: response.InsuranceCity,
                    instState: response.InsuranceState,
                    instZipCode: response.InsuranceZipCode,
                    PayerID: response.PayerID
                })
                setInsurancePlanSaveUpdateModal({})

            }).catch((error) => {

                NotificationHandler(error.message, enumUtil.enumtoaster.error);
                setIsLoading(false);

            })
        } else {

            setmainInsurancePlanModal({ ...mainInsurancePlanModal, Statuss: 'true' })
            setInsurancePlanSaveUpdateModal({ ...InsurancePlanSaveUpdateModal, Statuss: 'true' })
        }
    }
    const EmplyerDropdown = () => {
        // setIsLoading(true)
        ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.LAWYER,
            // "ID": id
        }).then((response) => {
            setIsLoading(false)
            setLawyerDropDown(response)
            // console.log(response, "option");
        }).catch((error) => {
            setIsLoading(false)
            // NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
        // setIsLoading(true)
        ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.EMPLOYER,
            // "ID": id
        }).then((response) => {
            setIsLoading(false)
            setEmployerDropDown(response)
            // console.log(response, "option");
        }).catch((error) => {
            setIsLoading(false)
            // NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
    }
    const handleDropDownApi = (id) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.INSURANCEADDRESSDROPDOWN,
            "ID": id + ''
        }).then((response) => {
            setIsLoading(false)
            setAddressDropdown(response)
            // console.log(response, "option");
        }).catch((error) => {
            setIsLoading(false)
            // NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={PatientInsuranceID + ""} TableName={enumUtil.enumAPITableName.PatientInsurance} />
    }
    useEffect(() => {
        handleInsurranceDetails();
    }, [insurancDetails])
    useEffect(() => {
        // if (!NewSubscriberID) {
        handleFindBy();
        // }
    }, [PatientInsuranceID, NewSubscriberID, NewInsuranceID, insurancDetails]);
    const handleInsurancePlanChange = (e) => {
        setIs(true)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainInsurancePlanModal };
        let saveModal = { ...InsurancePlanSaveUpdateModal }
        if (name === 'RelationShipCode' && value === '18') {
            modal[name] = value
            if (PatientInsuranceID != '0' || PatientInsuranceID != '-1') {
                ServerRequestProtected(API_URL + "/FindByID", 'post', {
                    "ID": PateintIDR + "",
                    "TableName": enumUtil.enumAPITableName.Patient
                }).then((response) => {
                    setIs(true)
                    const { LastName, FirstName, MI, DOB, SSN, Gender, AddressLine1, AddressLine2, City, State, ZipCode } = response;
                    const patientData = {
                        LastName,
                        FirstName,
                        MI,
                        DOB,
                        SSN,
                        Gender,
                        AddressLine1,
                        AddressLine2,
                        City,
                        State,
                        ZipCode
                    };
                    setmainInsurancePlanModal(prevState => ({ ...prevState, ...patientData }));
                    setInsurancePlanSaveUpdateModal(prevState => ({ ...prevState, ...patientData }));
                }).catch((error) => {
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                    setIsLoading(false)
                })
            }
        } else if (name === 'ZipCode') {
            GetZipCode(value)
                .then(data => {
                    setmainInsurancePlanModal(prevState => ({ ...prevState, ...data?.main }));
                    setInsurancePlanSaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
                })
                .catch(error => {
                });
            modal[name] = value;
        } else {
            if (name === "AcceptAssignment" || name === 'Statuss' || name === 'Hospice' || name === 'AccidentIllnesInfoInClaim') {
                modal[name] = !modal[name]
            } else {
                modal[name] = value
            }
        }
        setmainInsurancePlanModal(modal)
        for (var property in InsurancePlan_Modal) {
            if (name === property) {
                if (name === "AcceptAssignment" || name === 'Statuss' || name === 'Hospice' || name === 'AccidentIllnesInfoInClaim') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setInsurancePlanSaveUpdateModal(saveModal)
    }
    const handleImageChange = (e) => {
        const { name, files } = e.target;
        const file = files[0];
        const modalCopy = { ...mainInsurancePlanModal };
        const saveModalCopy = { ...InsurancePlanSaveUpdateModal };
        if (name === 'FileFrontSide') {
            modalCopy['FileNameFront'] = file.name;
            saveModalCopy['FileNameFront'] = file.name;
        } else if (name === 'FileBackSide') {
            modalCopy['FileNameBack'] = file.name;
            saveModalCopy['FileNameBack'] = file.name;
        }
        setmainInsurancePlanModal(modalCopy);
        const fileType = file.type.substring(0, 5);
        if (fileType === 'image') {
            const reader = new FileReader();
            reader.onloadend = (event) => {
                const value = reader.result.toString();
                modalCopy[name] = value;
                setmainInsurancePlanModal(modalCopy);

                for (const property in modalCopy) {
                    if (name === property) {
                        saveModalCopy[name] = event.target.result.split("base64,")[1];
                    }
                }

                setInsurancePlanSaveUpdateModal(saveModalCopy);
            };
            reader.readAsDataURL(file);
        }
    }
    const handleRemoveImage = (type) => {
        if (type === 'FileFrontSide') {
            let path = mainInsurancePlanModal.FileFrontSide

            setInsurancePlanSaveUpdateModal({ ...InsurancePlanSaveUpdateModal, FileFrontPath: path, FileFrontSide: "", FileNameFront: '' })
            setmainInsurancePlanModal({ ...mainInsurancePlanModal, FileFrontSide: null, FileNameFront: '' })

            // mainInsurancePlanModal.FileFrontSide = null
            // mainInsurancePlanModal.FileNameFront = "";
            // InsurancePlanSaveUpdateModal["FileFrontSide"] = '';
        } else if (type === 'FileBackSide') {
            let path = mainInsurancePlanModal.FileBackSide
            setInsurancePlanSaveUpdateModal({ ...InsurancePlanSaveUpdateModal, FileBackPath: path, FileBackSide: "", FileNameBack: '' })
            setmainInsurancePlanModal({ ...mainInsurancePlanModal, FileBackSide: null, FileNameBack: '', })

            // mainInsurancePlanModal.FileBackSide = null
            // mainInsurancePlanModal.FileNameBack = "";
            // InsurancePlanSaveUpdateModal["FileBackSide"] = '';
        }
    }
    const InsurancePlanValidation = async () => {
        let ValidationModal = {
            LastNameVal: FormValidator(
                mainInsurancePlanModal.LastName,
                enumUtil.enumValidationType.Required,
                'Last Name',
            ),
            FirstNameVal: FormValidator(
                mainInsurancePlanModal.FirstName,
                enumUtil.enumValidationType.Required,
                'First Name',
            ),
            InsuranceNameVal: FormValidator(
                mainInsurancePlanModal.InsuranceName,
                enumUtil.enumValidationType.Required,
                'Insurance Name',
            ),
            SubscriberIDVal: FormValidator(
                mainInsurancePlanModal.SubscriberID,
                enumUtil.enumValidationType.Required,
                'Subscriber ID'
            ),

            CoveragePriorityVal: FormValidator(
                mainInsurancePlanModal.CoveragePriority,
                enumUtil.enumValidationType.Required,
                'Coverage Priority',
            ),
            RelationShipCodeVal: FormValidator(
                mainInsurancePlanModal.RelationShipCode,
                enumUtil.enumValidationType.Required,
                'RelationShip',
            ),
            ZipCodelengthVal: FormValidator(
                mainInsurancePlanModal.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            ZipCodeVal: FormValidator(
                mainInsurancePlanModal.ZipCode,
                enumUtil.enumValidationType.Digit,
                'Zip Code'
            ),
            MIVal: FormValidator(
                mainInsurancePlanModal.MI,
                enumUtil.enumValidationType.Alphabet,
                "MI"
            ),
            SSNLengthVal: FormValidator(
                mainInsurancePlanModal.SSN,
                enumUtil.enumValidationType.Length,
                'SSN',
                9
            ),
            SSNVal: FormValidator(
                mainInsurancePlanModal.SSN,
                enumUtil.enumValidationType.Digit,
                'SSN'
            ),
        }
        await setInsurancePlanValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const SaveInsuranceRecord = async () => {
        await InsurancePlanValidation();
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            InsurancePlanSaveUpdateModal["PatientID"] = PateintIDR + "";
            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientInsurance,
                ID: PatientInsuranceID + "",
                data: { ...InsurancePlanSaveUpdateModal },
                value: null
            };
            setIsLoading(true);
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal).then((response) => {
                if (!isNull(response.id)) {
                    if (PatientInsuranceID === '0') {
                        // setisSaved(true)
                    } else {
                        setisisUpdated(true)
                        let UpdateSubscriberID = InsurancePlanSaveUpdateModal['SubscriberID'];
                        let UpdateInsuranceID = InsurancePlanSaveUpdateModal['InsuranceID'];
                        let UpdateInsuranceName = InsurancePlanSaveUpdateModal['InsuranceName'];
                        let hasPreviousSbrID = previousSubscriberID !== '';
                        let hasPreviousInsID = previousInsuranceID !== '';
                        let isSbrIDChanged = hasPreviousSbrID && claimsCount > 0 && UpdateSubscriberID && Number(previousSubscriberID) !== Number(UpdateSubscriberID);
                        let isInsIDChanged = hasPreviousInsID && claimsCount > 0 && UpdateInsuranceID && Number(previousInsuranceID) !== Number(UpdateInsuranceID);
                        // Set new IDs if present
                        if (hasPreviousSbrID && UpdateSubscriberID) setNewSubscriberID(UpdateSubscriberID);
                        if (hasPreviousInsID && UpdateInsuranceID) setNewInsuranceID(UpdateInsuranceID); setNewInsuranceName(UpdateInsuranceName);
                        // Only proceed if any of the IDs changed
                        if (isSbrIDChanged || isInsIDChanged) {
                            // Determine what changed and act accordingly
                            if (isSbrIDChanged && isInsIDChanged) {
                                setIsIDsUpdated({
                                    SbrIDUpdated: true,
                                    InsIDUpdated: true,
                                })
                                setupdatesubscriberID(true);
                                setUpdateInsuranceID(true);
                                setClaimFor('BOTH');
                            } else if (isSbrIDChanged) {
                                setIsIDsUpdated({
                                    SbrIDUpdated: true,
                                    InsIDUpdated: false,
                                })
                                setupdatesubscriberID(true);
                                setClaimFor('SBRID');
                            } else if (isInsIDChanged) {
                                setIsIDsUpdated({
                                    SbrIDUpdated: false,
                                    InsIDUpdated: true,
                                })
                                setUpdateInsuranceID(true);
                                setClaimFor('INSURANCE');
                            }

                            setUpdateAlertPopup(true);
                            setIsLoading(false);
                        }
                    }
                    setInsuranceDetails(Math.random())
                    // }
                    handleMissingData(response.id + "")
                    setInsurancePlanSaveUpdateModal({})
                    setCreatePlan(false)
                    setIsLoading(false)
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                }
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    const handleSaveInsurancePlan = async () => {
        if (!isNull(mainInsurancePlanModal.SubscriberID)) {
            setIsLoading(true)
            handleSaveSelfPay()
            SaveInsuranceRecord()
        } else if (isSelfPayChanged) {
            setIsLoading(true)
            handleSaveSelfPay(true)
        } else {
            SaveInsuranceRecord();
        }
    }
    const handleActivePlan = (ID) => {
        InsuranceListModal.map((item) => {
            if (item.PatientInsuranceID === ID) {
                mainEligibilityModal.PatientInsuranceID = item.InsuranceName
                EligibilitySaveUpdate.PatientInsuranceID = item.PatientInsuranceID + ""
            }
        })
        setisisUpdatedID(ID)
        if (activeTab !== ID) {
            setActiveTab(ID)
        }
        setPatientInsuranceID(ID)
    }
    const AddNewPlan = () => {
        setIs(true)
        setCreatePlan(true)
        if (InsuranceListModal.length === 0) {
            setmainInsurancePlanModal({ ...InsurancePlan_Modal, CoveragePriority: 'Primary', RelationShipCode: '18 - Self' })
            setInsurancePlanSaveUpdateModal({ ...InsurancePlanSaveUpdateModal, CoveragePriority: 'P', RelationShipCode: '18' })
            LoadRelationShipData()
        } else {
            let isPriamryInactive = false
            InsuranceListModal.map((item) => {
                if (item.CoveragePriority === 'P' && item.STATUS === false) {
                    isPriamryInactive = true
                } else if (item.CoveragePriority === 'P' && item.STATUS === true) {
                    isPriamryInactive = false
                }
            })
            if (isPriamryInactive) {
                setmainInsurancePlanModal({ ...InsurancePlan_Modal, CoveragePriority: 'Primary', RelationShipCode: '18 - Self' })
                setInsurancePlanSaveUpdateModal({ ...InsurancePlanSaveUpdateModal, CoveragePriority: 'P', RelationShipCode: '18' })
                LoadRelationShipData()
            } else {
                setmainInsurancePlanModal(InsurancePlan_Modal)
            }
        }
        InsuranceListModal.unshift({
            PatientInsuranceID: "-1",
            CoveragePriority: "",
            InsuranceName: "",
        });
        setPatientInsuranceID('0')
        setActiveTab('-1')

    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainInsurancePlanModal };
        let saveModal = { ...InsurancePlanSaveUpdateModal }
        modal[type] = FormatedDate
        if (type === 'EffectiveFrom' && modal.EffectiveTo && new Date(FormatedDate) > new Date(modal.EffectiveTo)) {
            modal.EffectiveTo = null;
            saveModal.EffectiveTo = null;
        }
        setmainInsurancePlanModal(modal)
        for (var property in InsurancePlan_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setInsurancePlanSaveUpdateModal(saveModal)
    }
    const LoadRelationShipData = () => {
        ServerRequestProtected(API_URL + "/FindByID", 'post', {
            "ID": PateintIDR + "",
            "TableName": enumUtil.enumAPITableName.Patient
        }).then((response) => {
            setIs(true)
            const { LastName, FirstName, MI, DOB, SSN, Gender: GenderValue, AddressLine1, AddressLine2, City, State: StateValue, ZipCode } = response;
            const genderObject = Gender.find(g => g.value === GenderValue);
            const Stateobject = States.find(g => g.value === StateValue);
            const patientData = {
                LastName,
                FirstName,
                MI,
                DOB,
                SSN,
                Gender: genderObject ? genderObject.display : '',
                AddressLine1,
                AddressLine2,
                City,
                State: Stateobject ? Stateobject.display : '',
                ZipCode
            };
            setmainInsurancePlanModal(prevState => ({ ...prevState, ...patientData }));
            setInsurancePlanSaveUpdateModal(prevState => ({ ...prevState, ...patientData }));
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
    }
    const handleSelectedData = (selectedData, name, type) => {
        setIs(true);
        let modal = { ...mainInsurancePlanModal };
        let modalEligibility = { ...mainEligibilityModal };
        if (type === 'client' && !isNull(selectedData)) {

            if (name === 'PlanState') {
                modal[name] = selectedData.display
                InsurancePlanSaveUpdateModal[name] = selectedData.value + "";
                InsurancePlanSaveUpdateModal['PayerID'] = selectedData.value + "";
            } else if (name === 'RelationShipCode') {
                modal[name] = selectedData.display
                InsurancePlanSaveUpdateModal[name] = selectedData.value + "";
                if (selectedData.value === '18') {
                    LoadRelationShipData()
                }
            } else {
                modal[name] = selectedData.display
                InsurancePlanSaveUpdateModal[name] = selectedData.value + "";
            }

        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'InsuranceID') {
                console.log(selectedData, 'selectedData');

                modal['InsuranceName'] = selectedData.display
                InsurancePlanSaveUpdateModal[name] = selectedData.value + "";
                handleDropDownApi(selectedData.value)
                setInsuranceID(selectedData.value + "")
                InsurancePlanSaveUpdateModal['InsuranceName'] = selectedData.ShortName + "";
                modal['instAdd1'] = selectedData.AddressLine1
                modal['instAdd2'] = selectedData.AddressLine2
                modal['instCity'] = selectedData.City
                modal['instState'] = selectedData.State
                modal['instZipCode'] = selectedData.ZipCode
                modal['PayerID'] = selectedData.PayerID
                modal['ShortName'] = selectedData.ShortName
            }
        } else {
            modal[name] = ''
            modal['InsuranceName'] = ''
            modalEligibility[name] = ''
            InsurancePlanSaveUpdateModal['InsuranceName'] = ''
            InsurancePlanSaveUpdateModal['PatientInsuranceAddress'] = ''
            EligibilitySaveUpdate[name] = ''
            modal['ShortName'] = ''
            modal['PatientInsuranceAddress'] = ''
            setInsuranceID(0)
        }
        setmainInsurancePlanModal(modal)
        setmainEligibilityModal(modalEligibility)
        return selectedData
    }
    const handleInsuranceChange = (e) => {
        setIs(false)
        mainInsurancePlanModal.InsuranceName = e.target.value
        setinsuranceBody({ "TableName": enumUtil.enumAPITableName.Insurance, "SearchParam": e.target.value })
    }
    // const handleShowLivePre = async () => {
    //     setIsLoading(true);
    //     try {
    //         const [frontResponse, backResponse] = await Promise.all([
    //             mainInsurancePlanModal?.FileFrontExist === 'true' ? ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
    //                 "BucketPath": mainInsurancePlanModal.FileFrontSide
    //             }, 'Download') : Promise.resolve(null),
    //             mainInsurancePlanModal?.FileBackExist === 'true' ? ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
    //                 "BucketPath": mainInsurancePlanModal.FileBackSide
    //             }, 'Download') : Promise.resolve(null)
    //         ]);
    //         const frontBlob = frontResponse;
    //         const objectURLFront = frontBlob ? URL.createObjectURL(frontBlob) : "";
    //         const backBlob = backResponse;
    //         const objectURLBack = backBlob ? URL.createObjectURL(backBlob) : "";
    //         setmainInsurancePlanModal({
    //             ...mainInsurancePlanModal,
    //             FileFrontSideView: objectURLFront,
    //             FileBackSideView: objectURLBack
    //         });

    //         setShowLivePre(true);
    //         setModalActive(true);

    //     } catch (error) {
    //         NotificationHandler(error.message, enumUtil.enumtoaster.error);
    //     } finally {
    //         setIsLoading(false);
    //     }

    // }
    const [prictureData, setPrictureData] = useState({ type: "", FileName: '' })
    const handleShowLivePre = async (type) => {
        setIsLoading(true);
        try {
            const [frontResponse, backResponse] = await Promise.all([
                type === 'Front' ?
                    mainInsurancePlanModal?.FileFrontExist === 'true' ? ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
                        "BucketPath": mainInsurancePlanModal.FileFrontSide
                    }, 'Download') : Promise.resolve(null)

                    :

                    mainInsurancePlanModal?.FileBackExist === 'true' ? ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
                        "BucketPath": mainInsurancePlanModal.FileBackSide
                    }, 'Download') : Promise.resolve(null)
            ]);
            const frontBlob = frontResponse;
            const objectURLFront = frontBlob ? URL.createObjectURL(frontBlob) : "";
            const backBlob = backResponse;
            const objectURLBack = backBlob ? URL.createObjectURL(backBlob) : "";
            setmainInsurancePlanModal({
                ...mainInsurancePlanModal,
                FileFrontSideView: objectURLFront,
                FileBackSideView: objectURLBack
            });

            setShowLivePre(true);
            setPrictureData({ type: type, FileName: type === 'Front' ? mainInsurancePlanModal.FileNameFront : mainInsurancePlanModal.FileNameBack })
            setModalActive(true);

        } catch (error) {
            NotificationHandler(error.message, enumUtil.enumtoaster.error);
        } finally {
            setIsLoading(false);
        }

    }
    const EligibilityValidation = async () => {
        let ValidationModal = {
            PatientInsuranceIDval: FormValidator(
                mainEligibilityModal.PatientInsuranceID,
                enumUtil.enumValidationType.Required,
                'Insurance Name',
            ),
        }
        await setEligibilityValidationModal(ValidationModal)
        ValModalEligibility = ValidationModal
    }
    const handleEligibilityChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainEligibilityModal };
        let saveModal = { ...EligibilitySaveUpdate }
        if (name === "UsePracticeNPI") {
            modal[name] = !modal[name]
        } else {
            modal[name] = value
        }
        setmainEligibilityModal(modal)
        for (var property in Eligibility_Modal) {
            if (name === property) {
                if (name === "UsePracticeNPI") {
                    saveModal[name] = modal[name] + ""
                }
            }
        }
        setEligibilitySaveUpdate(saveModal)
    }
    const handleSaveEligibility = async () => {
        if (PerformEligibilityAllowed) {
            await EligibilityValidation()
            let validation = FormValidator([ValModalEligibility], enumUtil.enumValidationType.NullCheck)
            if (validation) {
                NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
                return
            } else {
                EligibilitySaveUpdate['UsePracticeNPI'] = mainEligibilityModal.UsePracticeNPI + ""
                if (isNull(EligibilitySaveUpdate.ProviderID)) {
                    EligibilitySaveUpdate['ProviderID'] = ''
                }
                let saveModal = {
                    TableName: enumUtil.enumAPITableName.Generate270,
                    data: [{ ...EligibilitySaveUpdate }],
                }
                setIsLoading(true)
                ServerRequestProtected(API_URL_Eligibility + "/EligibilityRequest", 'post', saveModal).then((response) => {
                    let msg = response.results.length != 0 ? response.results[0].validationMsg : response.errorMessage;
                    setMessage(msg);
                    setPerformClaimStatusData(response)
                    if (!isNull(response)) {
                        if (!isNull(response.errorMessage)) {
                            // NotificationHandler(response.errorMessage, enumUtil.enumtoaster.error)
                        } else {
                            setEligibilityBody(!EligibilityBody)
                            setEligibilityPopup(true)
                            setEligibilityID(response.trnControlNumber)
                            // NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        }
                    }
                    setIsLoading(false)
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
            }
        }

    }
    const handleDropDownChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...mainInsurancePlanModal };
        modal[name] = value
        setmainInsurancePlanModal(modal)
    }
    const handleOpenInsurance = () => {
        setIsOpenInsurance(true)
    }
    const CloseInsurance = () => {
        setIsOpenInsurance(false)
    }
    const CloseEligibilityPopup = () => {
        setEligibilityPopup(false)
    }
    const handleCloseLivePre = () => {
        setShowLivePre(false)
    }
    let PopupInsuranceScreen = "";
    if (IsOpenInsurance) {
        PopupInsuranceScreen = <AddNewInsurance IsOpenInsurance={IsOpenInsurance} onClose={CloseInsurance} InsuranceID={InsuranceID} onDeleteInsurance={CloseInsurance} />
    }
    const DownloadFile = (type) => {
        let BucketPath
        let filename
        if (type === 'FileFrontSide') {
            BucketPath = mainInsurancePlanModal.FileFrontSide
            filename = mainInsurancePlanModal.FileNameFront
        } else if (type === 'FileBackSide') {
            BucketPath = mainInsurancePlanModal.FileBackSide
            filename = mainInsurancePlanModal.FileNameBack
        }
        if (!isNull(BucketPath)) {
            setIsLoading(true)
            ServerRequestPublic(API_URL_Wasabi + "/DownloadFile", 'post', {
                "BucketPath": BucketPath
            }, "Download",)
                .then((response) => {
                    setIsLoading(false)
                    let blob = new Blob([response]);
                    saveAs(blob, filename);
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                })
        }
    }
    const handleMissingData = (ID) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/PatientReview", 'post', {
            "ID": ID,
            "TableName": enumUtil.enumAPITableName.PATIENTINSURANCEVALIDATION
        }).then((response) => {
            setIsLoading(false)
            setMissingData(true)
            let splitedData = response.split(';')
            setMissingDataInfo(splitedData)
        }).catch((error) => {
            // NotificationHandler(error.message, enumUtil.enumtoaster.error)
            setIsLoading(false)
            setMissingData(false)
        })

    }
    const handleOpenMissingData = () => {
        setIsOpenMissing(true)
    }
    const handleCheckBoxChange = (event) => {
        setisSelfPayChanged(true)
        const isChecked = event.target.checked;
        setBgBlur(isChecked)
        setIsSelfPay(isChecked);
    };
    const API_URL_TEMPLATE = enumUtil.controller.EHRTemplate
    const [isFormSubmitted, setisFormSubmitted] = useState(false)
    const GetIntakeFormStatus = () => {
        ServerRequestProtected(API_URL_TEMPLATE + "/GetInsuranceFormByID ", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
            "ID": PateintIDR + ""
        }).then((response) => {
            setisFormSubmitted(response.IsSubmitted)
            setPatientInsuranceTemplateDataID(response.PatientIntakeFormID + "")
        }).catch((error) => {
            setisFormSubmitted(false)
        })
    }
    // useEffect(() => {
    //     if (!isNull(props.Reload)) {
    //         let data = props.id
    //         data.map((item) => {
    //             if (item.key === 2131) {
    //                 handleInsurranceDetails()
    //             }
    //         })
    //         // if (data.length === 0) {
    //         //     handleInsurranceDetails()
    //         // }
    //     }
    // }, [props.Reload])
    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return; // skip on first render
        }

        if (!isNull(props.Reload)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 2131) {
                    handleInsurranceDetails()
                    GetIntakeFormStatus()
                    FindPatientPay()
                }
            })
            // if (data.length === 0) {
            //     handleInsurranceDetails()
            // }
        }
    }, [props?.Reload?.Reload]);
    const FindPatientPay = () => {
        ServerRequestProtected(API_URL + "/FindPatientPay ", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientInsurance,
            "SearchCriteria": { "PATIENTID": PateintIDR + "" },
        }).then((response) => {
            setBgBlur(response.IsSelfPayPatient)
            setIsSelfPay(response.IsSelfPayPatient)
            setInitialStateSelf(response.IsSelfPayPatient)
        }).catch((error) => {
        })
    }
    useEffect(() => {
        FindPatientPay()
        if (PatientInsuranceID === '0') {
            setmainInsurancePlanModal({ ...mainInsurancePlanModal, Statuss: true })
            setInsurancePlanSaveUpdateModal({ ...InsurancePlanSaveUpdateModal, Statuss: 'true' })
        }
        if (PateintIDR) {
            setPatientID(PateintIDR)
        }
        GetIntakeFormStatus()
    }, [])
    const handleSaveSelfPay = (notify) => {
        ServerRequestProtected(API_URL + "/SavePatientPay ", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientInsurance,
            "ID": PateintIDR + "",
            "Data": {
                "IsSelfPayPatient": isSelfPay + ""
            }
        }).then((response) => {
            if (notify) {
                NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
            }
            setIsLoading(false)
            setisSelfPayChanged(false)
        }).catch((error) => {
            setIsLoading(false)
        })
    }
    const getIconClass = (Status, isSelected) => {
        // console.log(Status, isSelected);
        // let  isSelected = activeTab === item.PatientInsuranceID
        if (Status && isSelected) {
            return "";
        } else if (Status && !isSelected) {
            return "opacity-40";
        } else if (Status === false && isSelected) {
            return "red";
        } else if (Status === false && isSelected === false) {
            return "red opacity-40";
        } else {
            return "blue opacity-40";
        }
    };
    const handleSubscriber = () => {
        setisOpenSubscriber(true);
        setUpdateAlertPopup(false);
    }
    const handleSubscriberClose = () => {
        setupdatesubscriberID(false);
        setUpdateInsuranceID(false);
        setIsIDsUpdated({
            SbrIDUpdated: false,
            InsIDUpdated: false,
        })
        setUpdateAlertPopup(false);
        handleFindBy();

        setpreviousSubscriberID(mainInsurancePlanModal?.SubscriberID);
        setpreviousInsuranceID(mainInsurancePlanModal?.InsuranceID);
        setpreviousInsuranceName(mainInsurancePlanModal?.ShortName);
        setClaimsCount(mainInsurancePlanModal?.CommanClaimCount)
        // setSbrClaimsCount(mainInsurancePlanModal?.SBRClaimCount);
        // setInsClaimsCount(mainInsurancePlanModal?.InsuranceClaimCount);
    }
    const onCloseSubscriber = () => {
        setisOpenSubscriber(false);
        setIsIDsUpdated({
            SbrIDUpdated: false,
            InsIDUpdated: false,
        })
        setupdatesubscriberID(false);
        setUpdateInsuranceID(false);
        setpreviousSubscriberID(mainInsurancePlanModal?.SubscriberID);
        setpreviousInsuranceID(mainInsurancePlanModal?.InsuranceID);
        setpreviousInsuranceName(mainInsurancePlanModal?.ShortName);
        setClaimsCount(mainInsurancePlanModal?.CommanClaimCount)
        // setSbrClaimsCount(mainInsurancePlanModal?.SBRClaimCount);
        // setInsClaimsCount(mainInsurancePlanModal?.InsuranceClaimCount);
    }
    let SubscriberPopup = "";
    if (isOpenSubscriber) {
        SubscriberPopup = <SubscriberUpdatePopup isOpenSubscriber={isOpenSubscriber} onClose={onCloseSubscriber} previousSubscriberID={previousSubscriberID} updatesubscriberID={NewSubscriberID} previousInsuranceID={previousInsuranceID} updateInsuranceID={NewInsuranceID} previousInsuranceName={previousInsuranceName} updateInsuranceName={NewInsuranceName} IsIDsUpdated={isIDsUpdated} ClaimFor={ClaimFor} InsuranceID={InsuranceID} PatientInsuranceID={PatientInsuranceID} isLoading={isLoading} handleFindBy={handleFindBy} />
    }
    const handleDeleteInsurance = (ID) => {
        setPatInsuranceDelID(ID)
        handleOpenDeleteModal()
        setIsLoading(true)
        ServerRequestProtected(API_URL_GENERAL + "/DeleteSingleRecord ", 'post', {
            "ID": ID,
            "TableName": enumUtil.enumAPITableName.PatientInsurance
        }).then((response) => {
            if (response === 'Record Delete Successfully') {
                setPatientInsuranceID("0")
                setmainInsurancePlanModal(InsurancePlan_Modal)
                setInsurancePlanSaveUpdateModal({})
                setInsuranceDetails(Math.random())
                NotificationHandler(response, enumUtil.enumtoaster.success);
            } else {
                NotificationHandler(response, enumUtil.enumtoaster.error);
            }
            setIsLoading(false)
        }).catch((error) => {
            NotificationHandler(error.message, enumUtil.enumtoaster.error);
            setIsLoading(false)
        })
    }
    const HandlShowAllInsurance = (show) => {
        setShowAllInsurances(!showAllInsurances)
        if (!show) {
            if (AllInsurances.length > 0) {
                handleActivePlan(AllInsurances[0].PatientInsuranceID)
                setPatientInsuranceID(AllInsurances[0].PatientInsuranceID)
            } else {
                setmainInsurancePlanModal(InsurancePlan_Modal)
                setInsurancePlanSaveUpdateModal({})
                setPatientInsuranceID('0')
            }
            setInsuranceListModal([...AllInsurances])
        } else {
            let data = [...AllInsurances.filter(item => item.STATUS === true)]
            setInsuranceListModal(data)
            if (data.length > 0) {
                handleActivePlan(data[0].PatientInsuranceID)
                setPatientInsuranceID(data[0].PatientInsuranceID)
            } else {
                setmainInsurancePlanModal(InsurancePlan_Modal)
                setInsurancePlanSaveUpdateModal({})
                setPatientInsuranceID('0')
            }
        }
    }
    const handleInsurancePlanChangeTime = (e) => {
        const { name, value } = e.target;

        let updatedValue = value;

        // Check if the field is AccidentTime and convert to 12-hour format with AM/PM
        if (name === 'AccidentTime') {
            const [hour, minute] = value.split(':');
            let hours = parseInt(hour);
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // convert 0 to 12
            updatedValue = `${hours}:${minute} ${ampm}`;
        }
        // setmainInsurancePlanModal(prevState => ({ ...prevState, ...data?.main }));
        // setInsurancePlanSaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
        setmainInsurancePlanModal(prev => ({
            ...prev,
            [name]: updatedValue
        }));
        setInsurancePlanSaveUpdateModal(prev => ({
            ...prev,
            [name]: updatedValue
        }));
    };
    // Delete insurances
    const [PatInsuranceDelID, setPatInsuranceDelID] = useState(null)
    const [isOpenDelete, setisOpenDelete] = useState(false);
    const handleOpenDeleteModal = (ID) => {
        if (IsDeleteAllowed) {
            setPatInsuranceDelID(ID)
            setisOpenDelete(true)
        }
    }
    const onCloseDelete = () => { setisOpenDelete(false) }
    const onCloseAfterDelete = () => {
        setPatientInsuranceID("0")
        setmainInsurancePlanModal(InsurancePlan_Modal)
        setInsurancePlanSaveUpdateModal({})
        setInsuranceDetails(Math.random())
    }
    let DeleteConfirmation = "";
    if (isOpenDelete) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenDelete} onCloseDelete={onCloseDelete} API_URL={API_URL_GENERAL} TableName={enumUtil.enumAPITableName.PatientInsurance} ID={PatInsuranceDelID} onClose={onCloseAfterDelete} />
    }
    const [isOpenLawyer, setIsOpenLawyer] = useState(false)
    const [isOpenEmployer, setIsOpenEmployer] = useState(false)
    const AddRefProvider = (ID) => {
        setIsOpenEmployer(true)
        // setNpiModal(true)
        // setRefProviderID(ID)
    }
    const CloseProvider = () => {
        setIsOpenEmployer(false)
    }
    const DeleteProvider = () => {
        setIsOpenEmployer(false)
        // setIsClose((Math.random()));
    }
    const AddLawyer = (ID) => {
        setIsOpenLawyer(true)
        // setNpiModal(true)
        // setRefProviderID(ID)
    }
    const CloseLawyer = () => {
        setIsOpenLawyer(false)
    }
    const DeleteLawyer = () => {
        setIsOpenLawyer(false)
        // setIsClose((Math.random()));
    }
    let EmployerPopup = ""
    if (isOpenEmployer) {
        EmployerPopup = <AddNewEmployer isOpenRefProvider={isOpenEmployer} onClose={CloseProvider} onDeleteProvider={DeleteProvider} />
    }
    let LawyerPopup = ""
    if (isOpenLawyer) {
        LawyerPopup = <AddnewLawyer isOpenRefProvider={isOpenLawyer} onClose={CloseLawyer} onDeleteProvider={DeleteLawyer} />
    }
    // Discard Changes
    const [initialState, setInitialState] = useState();
    const [initialStateSelf, setInitialStateSelf] = useState();
    let dispatch = useDispatch();
    const NullToEmpty = (data) => {
        let updatedData = data && data.map(item => {
            const updatedItem = { ...item };
            for (const key in updatedItem) {
                if (updatedItem[key] != null) {
                    updatedItem[key] = updatedItem[key] + "";
                } else if (updatedItem[key] === null) {
                    updatedItem[key] = "";
                }
            }
            return updatedItem;
        });
        return updatedData
    }
    const handleDiscardChanges = (hasChanged) => {
        if (hasChanged) {
            let DD = DropDowns
            DD?.DisCardActiveIds.Patient.map((item) => {
                if (item.PatientID + "" === PateintIDR + "") {
                    item.isInsuranceUpdated = true
                }
            })
            dispatch(GeneralDropDowns({ ...DD, DiscardIndicator: false }))
        } else {
            let DD = DropDowns
            DD?.DisCardActiveIds.Patient.map((item) => {
                if (item.PatientID + "" === PateintIDR + "") {
                    item.isInsuranceUpdated = false
                }
            })
            dispatch(GeneralDropDowns({ ...DD, DiscardIndicator: false }))
        }
    }
    const DispacthFalseToDD = () => {
        dispatch(GeneralDropDowns({ ...DropDowns, DiscardIndicator: false }))
    }
    useEffect(() => {
        if (PateintIDR !== -1) {
            if (!isNull(initialState)) {
                let main = NullToEmpty([mainInsurancePlanModal])[0]
                let copy = NullToEmpty([initialState])[0]
                if (DropDowns.DiscardIndicator) {
                    const hasChanged = !_.isEqual(main, copy);
                    handleDiscardChanges(hasChanged)
                }
            } else {
                DispacthFalseToDD()
            }
            // if (!isNull(initialStateSelf)) {
            //     if (DropDowns.DiscardIndicator) {
            //         const hasChangedSelf = !_.isEqual(initialStateSelf, isSelfPay);
            //         handleDiscardChanges(hasChangedSelf)
            //     }
            // } else {
            //     dispatch(GeneralDropDowns({ ...DropDowns, DiscardIndicator: false }))
            // }
        } else {
            DispacthFalseToDD()
        }
    }, [DropDowns.DiscardIndicator])
    const isOnPatientSubTab213 = DropDowns?.PatientSubActiveTab === 213;
    const enabled =
        isOnPatientSubTab213 &&
        props.ActivePatientID === PatientID;
    useKeyboardShortcut("s+c", handleSaveInsurancePlan, 300, enabled);

    // PAtient isnurance intake form
    const [IsOpenInsuranceForm, setIsOpenInsuranceForm] = useState(false)
    const handleOpenInsuranceForm = () => {
        setIsOpenInsuranceForm(true)
    }
    const handleCloseInsuranceForm = () => {
        setIsOpenInsuranceForm(false)
    }
    let MergeInsurancePopup
    if (IsOpenInsuranceForm) {
        MergeInsurancePopup = <MergeInsuranceForm mergeInfoFormInsurance={IsOpenInsuranceForm} onClose={handleCloseInsuranceForm} ID={PatientInsuranceTemplateDataID + ""} />
    }

    return (
        <>
            {MergeInsurancePopup}
            <div className="row m-0 create_plan">
                <div className="tabs-menu col-md-2 p-0">
                </div>
                <div className="col-md-10 position-relative d-flex align-items-center gap-10 justify-content-between">
                    {isFormSubmitted === 'true' && PatientPortalAccessRedux ?
                        <div className='ar-alert d-flex align-items-center gap-1 m-0 mb-2px'>
                            <i className='icon-alert'></i>
                            <p className='text'>Patient submitted <span className='heading'>Patient Insurance Form</span> that may update information displayed on this page.
                                <span className="validate-color cursor-pointer" onClick={handleOpenInsuranceForm}>Click to review and mark it as processed.</span>
                            </p>
                        </div> : <div></div>
                    }
                    <div className='d-flex align-items-center custom_check_box cheak_box gap-1 text-nowrap'>
                        <input
                            type="checkbox"
                            className="form-check-input mt-0"
                            name="IsSelfPayPatient"
                            id="IsSelfPayPatient"
                            checked={isSelfPay}
                            onChange={handleCheckBoxChange}
                        />
                        <label className='heading font-m'>Self Pay Patient</label>
                    </div>
                </div>

            </div>

            {errorPopup}
            {PopupInsuranceScreen}
            {AuditPopup}
            {LawyerPopup}
            {EmployerPopup}
            {SubscriberPopup}
            {DeleteConfirmation}
            {isLoading ? <Loader /> : null}
            <div className="tabs-container">
                <div className={`app-vertical-tabs create_plan ${bgBlur ? 'ar-paninfo' : ''}`}>
                    <div className="tabs-menu col-md-2">
                        <div className='za_Inactive-payer px-2 d-flex flex-column justify-content-center'>
                            <div class="custom_check_box check_boxes d-flex align-items-center gap-2">
                                <div>
                                    <input
                                        type="checkbox"
                                        className="form-check-input p-0"
                                        checked={showAllInsurances}
                                        onChange={() => HandlShowAllInsurance(showAllInsurances)}
                                    />
                                </div>
                                <p className="heading font-m" for="inlineCheckbox2">InActive Payers</p>
                            </div>
                        </div>
                        <div className='py-3 text-center'>
                            <button className='btn btn-theme btn-xs no-width' disabled={createPlan} onClick={AddNewPlan}> Create Plan</button>
                        </div>
                        {/* <button className='btn btn-xs no-width' onClick={() => HandlShowAllInsurance(showAllInsurances)}>{showAllInsurances ? 'Show Active' : 'Show All'}</button> */}
                        <Nav className='za-tabs hover-scrollbar' variant="tabs" >
                            {InsuranceListModal.length > 0 ? InsuranceListModal.map((item) => {
                                return (
                                    <React.Fragment key={item.PatientInsuranceID}>
                                        <NavItem onClick={() => handleActivePlan(item.PatientInsuranceID)}  >
                                            <NavLink href='#' className={activeTab === item.PatientInsuranceID ? "active" : ""}>
                                                <div className='tab-img' >
                                                    {/* {item.STATUS === true && activeTab === item.PatientInsuranceID ?  // if insurancre is active and selected 
                                                        <i className="icon-book-green fs-60"></i> :
                                                        item.STATUS && activeTab !== item.PatientInsuranceID ?  // if insurancre is active and not selected 
                                                            <i className="icon-book-green-light fs-60"></i> :
                                                            item.STATUS === false && activeTab === item.PatientInsuranceID ?
                                                                <i className="icon-book-red fs-60"></i> :
                                                                item.STATUS === false && activeTab !== item.PatientInsuranceID ?
                                                                    <i className="icon-book-red-light fs-60"></i> : null
                                                    } */}
                                                    {/* <i className=></i> */}
                                                    <span className={`icon-insurance-patient fs-60 ${getIconClass(item.STATUS, activeTab === item.PatientInsuranceID)}`}><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
                                                    {/* <img src={activeTab === item.PatientInsuranceID ? process.env.PUBLIC_URL + "/assets/images/Icon awesome-book-medical.svg"
                                                        : process.env.PUBLIC_URL + "/assets/images/awesome-book-medical-1.svg"} alt="book icon" /> */}
                                                    <div className={item.CoveragePriority === "P" ? "hk-status p" : item.CoveragePriority === "S" ? "hk-status s" : item.CoveragePriority === "T" ? "hk-status T" : item.CoveragePriority === "O" ? "hk-status O" : ''}>
                                                        {item.CoveragePriority === "P" ? "P" : item.CoveragePriority === "S" ? "S" : item.CoveragePriority === "T" ? "T" : item.CoveragePriority === "O" ? "O" : ''}
                                                    </div>
                                                    {PatientInsuranceID !== "0" ?
                                                        <div className={IsDeleteAllowed ? 'ar-delte-plan d-flex p-1' : 'ar-delte-plan d-flex p-1 disabled'} onClick={() => handleOpenDeleteModal(item.PatientInsuranceID)}>
                                                            <i className='icon-Icon-metro-cross'></i>
                                                        </div>
                                                        : null}
                                                </div>
                                                {item.ShortName}
                                            </NavLink>
                                        </NavItem>
                                    </React.Fragment>
                                )
                            }) : null}
                        </Nav>
                    </div>
                    <div className="col-md-10 position-relative d-flex flex-column justify-content-between">
                        <div className="row planinfo_screen_size">
                            <div className="col-md-6 app-accordian ps-2 pe-0">
                                <Accordion expanded={true}>
                                    <AccordionSummary
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <div className='d-flex align-items-baseline justify-content-between w-100 insured_party'>
                                            <p className="heading">Insured Party</p>
                                            <div class="form-check    form-switch radio_button">
                                                <label class="form-check-label" for="mySwitch">Active</label>
                                                <input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    id="mySwitch"
                                                    name="Statuss"
                                                    checked={mainInsurancePlanModal.Statuss}
                                                    onChange={handleInsurancePlanChange}
                                                />
                                            </div>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row'>
                                            <div className="col-md-4">
                                                <div className={InsurancePlanValidationModal.CoveragePriorityVal ? 'form-group input error' : 'form-group input m-0'}>
                                                    <label>Coverage Priority<span className='req'>*</span></label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='CoveragePriority'
                                                        name='CoveragePriority'
                                                        searchValue={mainInsurancePlanModal.CoveragePriority}
                                                        data={CoveragePriority}
                                                        onChange={handleDropDownChange}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                        inputError={InsurancePlanValidationModal.CoveragePriorityVal}
                                                    />
                                                    {InsurancePlanValidationModal.CoveragePriorityVal}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className={InsurancePlanValidationModal.RelationShipCodeVal ? 'input error' : 'input m-0'}>
                                                    <label htmlFor="Plan_RelationShipCode">Relation<span className='req'>*</span></label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='RelationShipCode'
                                                        name='RelationShipCode'
                                                        searchValue={mainInsurancePlanModal.RelationShipCode}
                                                        data={Relationship}
                                                        onChange={handleDropDownChange}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                        inputError={InsurancePlanValidationModal.RelationShipCodeVal}
                                                    />
                                                    {InsurancePlanValidationModal.RelationShipCodeVal}
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className='input'>
                                                    <label htmlFor="Plan_LastName">Last Name<span className='req'>*</span></label>
                                                    <div className={InsurancePlanValidationModal.LastNameVal ? 'form-group input error' : 'form-group input m-0'}>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="LastName"
                                                            id="Plan_LastName"
                                                            value={mainInsurancePlanModal.LastName}
                                                            onChange={handleInsurancePlanChange} />
                                                        {InsurancePlanValidationModal.LastNameVal}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4 mt-2">
                                                <div className='input'>

                                                    <label htmlFor="Plan_FirstName">First Name<span className='req'>*</span></label>
                                                    <div className={InsurancePlanValidationModal.FirstNameVal ? 'form-group input error' : 'form-group input m-0'}>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="FirstName"
                                                            id="Plan_FirstName"
                                                            value={mainInsurancePlanModal.FirstName}
                                                            onChange={handleInsurancePlanChange} />
                                                        {InsurancePlanValidationModal.FirstNameVal}
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label htmlFor="Plan_MI">MI</label>
                                                    <div className={InsurancePlanValidationModal.MIVal ? 'form-group input error' : 'input'}>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="MI"
                                                            id="Plan_MI"
                                                            maxLength={3}
                                                            value={mainInsurancePlanModal.MI}
                                                            onChange={handleInsurancePlanChange} />
                                                        {InsurancePlanValidationModal.MIVal}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label htmlFor="Plan_Gender">Sex</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='Gender'
                                                        name='Gender'
                                                        searchValue={mainInsurancePlanModal.Gender}
                                                        data={Gender}
                                                        onChange={handleDropDownChange}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <DatePicker
                                                    label='DOB'
                                                    value={mainInsurancePlanModal.DOB}
                                                    handleCalendarChangefunc={date => handleCalendarChange(date, 'DOB')}
                                                />
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <div className='form-group input'>
                                                        <label htmlFor="Plan_SSN">SSN</label>
                                                        <div className={InsurancePlanValidationModal.SSNLengthVal || InsurancePlanValidationModal.SSNVal ? 'form-group input error' : 'input'}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="SSN"
                                                                id="Plan_SSN"
                                                                maxLength={9}
                                                                onKeyPress={handleNumericCheck}
                                                                value={mainInsurancePlanModal.SSN}
                                                                onChange={handleInsurancePlanChange} />
                                                            {InsurancePlanValidationModal.SSNLengthVal || InsurancePlanValidationModal.SSNVal}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-12 row insParty pe-0'>
                                                <div className="col-md-6">
                                                    <div className='input'>
                                                        <label htmlFor="Plan_AddressLine1">Address Line 1</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="AddressLine1"
                                                            id="Plan_AddressLine1"
                                                            maxLength={55}
                                                            value={mainInsurancePlanModal.AddressLine1}
                                                            onChange={handleInsurancePlanChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 pe-0">
                                                    <div className='input'>
                                                        <label htmlFor="Plan_AddressLine2">Address Line 2</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="AddressLine2"
                                                            id="Plan_AddressLine2"
                                                            maxLength={55}
                                                            value={mainInsurancePlanModal.AddressLine2}
                                                            onChange={handleInsurancePlanChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 insParty">
                                                <div className='input'>
                                                    <label htmlFor="Plan_City">City</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="City"
                                                        id="Plan_City"
                                                        maxLength={30}
                                                        value={mainInsurancePlanModal.City}
                                                        onChange={handleInsurancePlanChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-4 insParty">
                                                <div className='input'>
                                                    <label htmlFor="State">State</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='State'
                                                        name='State'
                                                        searchValue={mainInsurancePlanModal.State}
                                                        data={States}
                                                        onChange={handleDropDownChange}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 insParty">
                                                <div className='form-group input'>
                                                    <label htmlFor="Plan_ZipCode">ZIP</label>
                                                    <div className={InsurancePlanValidationModal.ZipCodelengthVal || InsurancePlanValidationModal.ZipCodeVal ? 'input error' : 'input'}>
                                                        {/* <div className='input'> */}
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="ZipCode"
                                                            id="Plan_ZipCode"
                                                            maxLength={9}
                                                            onKeyPress={handleNumericCheck}
                                                            value={mainInsurancePlanModal.ZipCode}
                                                            onChange={handleInsurancePlanChange} />
                                                        {InsurancePlanValidationModal.ZipCodelengthVal || InsurancePlanValidationModal.ZipCodeVal}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <div className="col-md-6 app-accordian px-2">
                                <Accordion defaultExpanded>
                                    <AccordionSummary
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"

                                    >
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <p className="heading">Plan</p>
                                            <div className='d-flex align-items-center gap-2'>

                                                <button className="btn btn-orange hk-accordian-btn" onClick={() => setEligibilityBody(!EligibilityBody)}>
                                                    Perform Eligibility
                                                </button>
                                                <span className="icon">
                                                    <i
                                                        aria-describedby={Boolean(isOpenAudit) ? 'simple-popper' : undefined}
                                                        type="button"
                                                        className=' icon-menu-1'
                                                        onClick={handleAuditModal}
                                                    >
                                                        <i className="path1"></i>
                                                        <i className="path2"></i>
                                                        <i className="path3"></i>
                                                        <i className="path4"></i>
                                                        <i className="path5"></i>
                                                        <i className="path6"></i>
                                                        <i className="path7"></i>
                                                        <i className="path8"></i>
                                                        <i className="path9"></i>
                                                        <i className="path10"></i>
                                                    </i>
                                                </span>
                                            </div>
                                        </div>

                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row row-half'>
                                            <div className="col-md-8">
                                                <div className='form-group input mb-0'>
                                                    <div className="label-head mb-0">
                                                        <div className="d-flex align-items-end">
                                                            <label htmlFor="PlanInfo_InsuranceID">Insurance Name<span className='req'>*</span></label>

                                                            {InsuranceID ? <i class="icon-icon-arrow-top-right" onClick={() => handleOpenInsurance()}></i> : null}
                                                        </div>
                                                    </div>
                                                    <div className={InsurancePlanValidationModal.InsuranceNameVal ? 'input error planSearch-module' : 'input planSearch-module'}>
                                                        <SuperSearchList
                                                            type='server'
                                                            id='InsuranceID'
                                                            name='InsuranceID'
                                                            searchValue={mainInsurancePlanModal.InsuranceName}
                                                            ApiLink={API_URL_GENERAL + "/InstantSearch"}
                                                            method='post'
                                                            postBody={insuranceBody}
                                                            onChange={handleInsuranceChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            icon={true}
                                                            InsuranceInst={true}
                                                            placeholder={"Search..."}
                                                            inputError={InsurancePlanValidationModal.InsuranceNameVal}
                                                        />
                                                        {InsurancePlanValidationModal.InsuranceNameVal}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className={InsurancePlanValidationModal.ShortNameVal ? 'input error planSearch-module' : 'input planSearch-module'}>
                                                    <label htmlFor="InsuranceName">Short Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="ShortName"
                                                        id="PlanInfo_ShortName"
                                                        readOnly
                                                        value={mainInsurancePlanModal.ShortName}
                                                        onChange={handleInsurancePlanChange}
                                                    />
                                                    {InsurancePlanValidationModal.ShortNameVal}
                                                </div>
                                            </div>
                                            <div className="col-md-12 yellow-box mt-2">
                                                {/* <p className='mb-0'>
                                                    Address:
                                                    {' '}{!isNull(mainInsurancePlanModal.instAdd1) ? mainInsurancePlanModal.instAdd1 : 'N/A'}
                                                    {!isNull(mainInsurancePlanModal.instAdd1) ? mainInsurancePlanModal.instAdd2 + ', ' : ''}
                                                    {mainInsurancePlanModal.instCity}
                                                    {!isNull(mainInsurancePlanModal.instCity) ? mainInsurancePlanModal.instState + ', ' : ''}
                                                    {!isNull(mainInsurancePlanModal.instState) ? mainInsurancePlanModal.instZipCode : ''}
                                                </p> */}
                                                <div className="col-md-12">
                                                    <div className={InsurancePlanValidationModal.ShortNameVal ? 'input error planSearch-module' : 'input planSearch-module'}>
                                                        <div className='input'>
                                                            <label htmlFor="State">Address</label>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='PatientInsuranceAddress'
                                                                name='PatientInsuranceAddress'
                                                                searchValue={mainInsurancePlanModal.PatientInsuranceAddress}
                                                                data={addressDropdown}
                                                                onChange={handleDropDownChange}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <p className="mb-0">Payer ID: {!isNull(mainInsurancePlanModal.PayerID) ? mainInsurancePlanModal.PayerID : ' N /A'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <div className='input'>
                                                    <label htmlFor="PlanInfo_SubscriberID" className='mt-2'>Subscriber ID<span className='req'>*</span></label>
                                                    <div className={InsurancePlanValidationModal.SubscriberIDVal ? 'form-group input error' : 'form-group input m-0'}>

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="SubscriberID"
                                                            id="PlanInfo_GroupNumber"
                                                            // onKeyPress={handleNumericCheck}
                                                            value={mainInsurancePlanModal.SubscriberID}
                                                            onChange={handleInsurancePlanChange} />
                                                        {InsurancePlanValidationModal.SubscriberIDVal}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className='input'>
                                                    <label htmlFor="PlanInfo_GroupNumber" className='mt-2'>Group Number</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="GroupNumber"
                                                        id="PlanInfo_GroupNumber"
                                                        value={mainInsurancePlanModal.GroupNumber}
                                                        onChange={handleInsurancePlanChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className='input'>
                                                    <label htmlFor="PlanInfo_GroupName" className='mt-2'>Group Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="GroupName"
                                                        id="PlanInfo_GroupName"
                                                        value={mainInsurancePlanModal.GroupName}
                                                        onChange={handleInsurancePlanChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <DatePicker
                                                    label='Effective Start Date'
                                                    value={mainInsurancePlanModal.EffectiveFrom}
                                                    handleCalendarChangefunc={date => handleCalendarChange(date, 'EffectiveFrom')}
                                                />
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <DatePicker
                                                    label='Effective End Date'
                                                    value={mainInsurancePlanModal.EffectiveTo}
                                                    minDate={mainInsurancePlanModal.EffectiveFrom ? new Date(mainInsurancePlanModal.EffectiveFrom) : null}
                                                    handleCalendarChangefunc={date => handleCalendarChange(date, 'EffectiveTo')}
                                                />
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label htmlFor="Copay">Copay</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="Copay"
                                                        id="Copay"
                                                        onKeyPress={handleDecimalCheck}
                                                        value={mainInsurancePlanModal.Copay}
                                                        onChange={handleInsurancePlanChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label htmlFor="PlanInfo_TotalDeductible">Deductible</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="TotalDeductible"
                                                        id="PlanInfo_TotalDeductible"
                                                        onKeyPress={handleDecimalCheck}
                                                        value={mainInsurancePlanModal.TotalDeductible}
                                                        onChange={handleInsurancePlanChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label htmlFor="PlanInfo_RemainingDeductible">Deductible Met</label>
                                                    <input type="text"
                                                        className="form-control"
                                                        name="RemainingDeductible"
                                                        id="PlanInfo_RemainingDeductible"
                                                        onKeyPress={handleDecimalCheck}
                                                        value={mainInsurancePlanModal.RemainingDeductible}
                                                        onChange={handleInsurancePlanChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label htmlFor="">WC Case #</label>
                                                    <input
                                                        className="form-control"
                                                        name="WCCase"
                                                        id="WCCase"
                                                        // onKeyPress={handleDecimalCheck}
                                                        value={mainInsurancePlanModal.WCCase}
                                                        onChange={handleInsurancePlanChange}
                                                    />
                                                </div>
                                            </div>






                                            {/* <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label htmlFor="">Employer</label>
                                                    <input
                                                        className="form-control"
                                                        name="Employer"
                                                        id="Employer"
                                                        value={mainInsurancePlanModal.Employer}
                                                        onChange={handleInsurancePlanChange}
                                                    />
                                                </div>
                                            </div> */}











                                            {/* <div className='row row-gap-15 row-half'>
                                                <div className="col-md-8">
                                                    <div className='input'>
                                                        <label htmlFor="PlanInfo_AddressLine2">Address</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="PlanAddressLine"
                                                            id="PlanInfo_AddressLine2"
                                                            value={mainInsurancePlanModal.PlanAddressLine}
                                                            onChange={handleInsurancePlanChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className='input'>
                                                        <label htmlFor="PlanInfo_City">City</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="PlanCity"
                                                            id="PlanInfo_City"
                                                            value={mainInsurancePlanModal.PlanCity}
                                                            onChange={handleInsurancePlanChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className='input'>
                                                        <label htmlFor="PlanInfo_State">State</label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='PlanState'
                                                            name='PlanState'
                                                            searchValue={mainInsurancePlanModal.PlanState}
                                                            data={States}
                                                            onChange={handleDropDownChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                        // filterWith="startsWith"
                                                        // tableHeight="200px"
                                                        // tableWidth="100%"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className='input'>
                                                        <label htmlFor="PlanInfo_ZipCode">ZIP</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="PlanZipCode"
                                                            id="PlanInfo_ZipCode"
                                                            value={mainInsurancePlanModal.PlanZipCode}
                                                            onChange={handleInsurancePlanChange} />
                                                    </div>
                                                </div>
                                            </div> */}


                                            {/* <div className="col-md-5 mt-4">
                                                {/* {isPateintImageSaved === false ? '' : */}
                                            {/* <div className='d-flex h-100 align-items-center gap-10'>
                                                    <i className='bi bi-eye-fill clr-theme fs-22 cursor-pointer' onClick={handleShowLivePre}></i>
                                                    {/* <p className="text font-sb fs-12 cursor-pointer">Show Live Preview</p> */}
                                            {/* </div>  */}

                                            {/* } */}
                                            {/* </div> */}

                                            <div>

                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion >
                                    <AccordionSummary
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <p className="heading">Additional Fields</p>
                                            {/* <i className='icon-up fs-8 ar-light-icon'></i> */}
                                        </div>

                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='row row-half'>

                                            <div className="col-md-4 mt-2">
                                                <DatePicker
                                                    label='Accident (Injury) Date'
                                                    // label='Effective Start Date'
                                                    value={mainInsurancePlanModal.AccidentDate}
                                                    handleCalendarChangefunc={date => handleCalendarChange(date, 'AccidentDate')}
                                                />
                                            </div>

                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label htmlFor="Plan_Gender">Accident State</label>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='AccidentState'
                                                        name='AccidentState'
                                                        searchValue={mainInsurancePlanModal.AccidentState}
                                                        data={States}
                                                        onChange={handleDropDownChange}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label htmlFor="Plan_Gender">Accident Type</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="AccidentType"
                                                        id="AccidentType"
                                                        // onKeyPress={handleNumericCheck}
                                                        value={mainInsurancePlanModal.AccidentType}
                                                        onChange={handleInsurancePlanChange} />
                                                    {/* <input type="time" className="form-control"
                                                        id='AccidentTime'
                                                        name='AccidentTime'
                                                        value={mainInsurancePlanModal.AccidentTime}
                                                        onChange={handleInsurancePlanChange}

                                                    /> */}
                                                </div>
                                            </div>
                                            {/* <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <label htmlFor="">Employer</label>
                                                    <input
                                                        className="form-control"
                                                        name="Employer"
                                                        id="Employer"
                                                        value={mainInsurancePlanModal.Employer}
                                                        onChange={handleInsurancePlanChange}
                                                    />
                                                </div>
                                            </div> */}

                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <div className='d-flex justify-content-between align-items-center mb-3px'>
                                                        <label htmlFor="Plan_Gender">Employer</label>
                                                        <button className="btn-icon-circle btn-xs hk-plusWrapper__Btn add_status-btn" onClick={AddRefProvider}><i className="icon-dash-plus"></i></button>
                                                    </div>

                                                    <SuperSearchList
                                                        type="client"
                                                        id='EmployerID'
                                                        name='EmployerID'
                                                        searchValue={mainInsurancePlanModal.EmployerID}
                                                        data={employerDropdown}
                                                        onChange={handleDropDownChange}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4 mt-2">
                                                <div className='input'>
                                                    <div className='d-flex justify-content-between align-items-center  mb-3px'>
                                                        <label htmlFor="Plan_Gender">Lawyer</label>
                                                        <button className="btn-icon-circle btn-xs hk-plusWrapper__Btn add_status-btn" onClick={AddLawyer}><i className="icon-dash-plus"></i></button>
                                                    </div>
                                                    <SuperSearchList
                                                        type="client"
                                                        id='LawyerID'
                                                        name='LawyerID'
                                                        searchValue={mainInsurancePlanModal.LawyerID}
                                                        data={lawyerDropdown}
                                                        onChange={handleDropDownChange}
                                                        getSelectedData={handleSelectedData}
                                                        is={is}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mt-2">
                                                <DatePicker
                                                    label='Last Seen Date'
                                                    value={mainInsurancePlanModal.LastSeenDate}
                                                    handleCalendarChangefunc={date => handleCalendarChange(date, 'LastSeenDate')}
                                                />
                                            </div>
                                            <div className="col-md-12 mt-1">
                                                <div className='col-md-8 pe-1'>
                                                    <div className="input">
                                                        <label htmlFor="Plan_Gender">Medicare Sec Plan Type</label>
                                                        {/* <div className='input-group hk-input-search'>
                                                            <input type="text" className='form-control fc-xs rounded-1' id='MedicareSecPlanType'
                                                                name='MedicareSecPlanType' />
                                                            <span className="input-group-text rounded-end">
                                                                <i className="bi bi-search"></i>
                                                            </span>
                                                        </div> */}
                                                        <SuperSearchList
                                                            type="client"
                                                            id='MedicareSecPlanType'
                                                            name='MedicareSecPlanType'
                                                            searchValue={mainInsurancePlanModal?.MedicareSecPlanType}
                                                            data={SecPlanTypeDD}
                                                            onChange={handleDropDownChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                        />

                                                    </div>
                                                </div>

                                            </div>

                                            <div className='col-md-12 mt-2'>
                                                <div className='d-flex '>
                                                    <div className="">
                                                        <div class="form-check custom_check_box check_boxes form-check-inline text-nowrap">
                                                            <div>
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input p-0"

                                                                    name="Hospice"
                                                                    id="Hospice"
                                                                    checked={mainInsurancePlanModal.Hospice}
                                                                    onChange={handleInsurancePlanChange}


                                                                />
                                                            </div>

                                                            <div>
                                                                <label class="form-check-label" for="inlineCheckbox2">Pat on Hospice</label>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="">
                                                        <div class="form-check custom_check_box check_boxes form-check-inline">
                                                            <div>
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input p-0"
                                                                    name="AccidentIllnesInfoInClaim"
                                                                    id="AccidentIllnesInfoInClaim"
                                                                    checked={mainInsurancePlanModal.AccidentIllnesInfoInClaim}
                                                                    onChange={handleInsurancePlanChange}

                                                                />
                                                            </div>

                                                            <div>
                                                                <label class="form-check-label text-nowrap" for="inlineCheckbox2">Include accident and illness info in claims </label>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div className="">
                                                        <div class="form-check custom_check_box check_boxes form-check-inline">
                                                            <div>
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input p-0"
                                                                    name="AcceptAssignment"
                                                                    id="AcceptAssignment"
                                                                    checked={mainInsurancePlanModal.AcceptAssignment}
                                                                    onChange={handleInsurancePlanChange}
                                                                />
                                                            </div>

                                                            <div>
                                                                <label class="form-check-label text-nowrap" for="inlineCheckbox2">Accept Assg</label>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className='row row-gap-15 row-half'>
                                                <div className="col-md-8">
                                                    <div className='input'>
                                                        <label htmlFor="PlanInfo_AddressLine2">Address</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="PlanAddressLine"
                                                            id="PlanInfo_AddressLine2"
                                                            value={mainInsurancePlanModal.PlanAddressLine}
                                                            onChange={handleInsurancePlanChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className='input'>
                                                        <label htmlFor="PlanInfo_City">City</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="PlanCity"
                                                            id="PlanInfo_City"
                                                            value={mainInsurancePlanModal.PlanCity}
                                                            onChange={handleInsurancePlanChange} />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className='input'>
                                                        <label htmlFor="PlanInfo_State">State</label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='PlanState'
                                                            name='PlanState'
                                                            searchValue={mainInsurancePlanModal.PlanState}
                                                            data={States}
                                                            onChange={handleDropDownChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                        // filterWith="startsWith"
                                                        // tableHeight="200px"
                                                        // tableWidth="100%"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className='input'>
                                                        <label htmlFor="PlanInfo_ZipCode">ZIP</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="PlanZipCode"
                                                            id="PlanInfo_ZipCode"
                                                            value={mainInsurancePlanModal.PlanZipCode}
                                                            onChange={handleInsurancePlanChange} />
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className="col-md-12 mt-2">
                                                <div className='input'>
                                                    <label htmlFor='PlanInfo_Comments'>Comments</label>
                                                    <textarea
                                                        rows="2" className='form-control'
                                                        name="Comment"
                                                        id="PlanInfo_Comments"
                                                        value={mainInsurancePlanModal.Comment}
                                                        onChange={handleInsurancePlanChange}
                                                    ></textarea>
                                                </div>
                                            </div>

                                            {/* <div className="col-md-5 mt-4">
                                                {/* {isPateintImageSaved === false ? '' : */}
                                            {/* <div className='d-flex h-100 align-items-center gap-10'>
                                                    <i className='bi bi-eye-fill clr-theme fs-22 cursor-pointer' onClick={handleShowLivePre}></i>
                                                    {/* <p className="text font-sb fs-12 cursor-pointer">Show Live Preview</p> */}
                                            {/* </div>  */}

                                            {/* } */}
                                            {/* </div> */}

                                        </div>
                                    </AccordionDetails>

                                </Accordion>
                                <Accordion>
                                    <AccordionSummary
                                        aria-controls="panel2a-content"
                                        id="panel2a-header"
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <p className="heading">Insurance Card</p>
                                            {/* <i className='icon-up fs-8 ar-light-icon'></i> */}
                                        </div>
                                    </AccordionSummary>

                                    <AccordionDetails>
                                        <div className="mt-2">
                                            <div className="input">
                                                <label>Attach Front Side</label>
                                                {mainInsurancePlanModal.FileNameFront ? (
                                                    <div className='d-flex gap-3 align-items-center mt-1'>
                                                        <p className='heading fst-italic'>{mainInsurancePlanModal.FileNameFront} <span className='ms-2'> 30 KB</span></p>
                                                        <div className='d-flex align-items-center gap-1'>
                                                            <div className="hk-uploadFile__btns m-0">
                                                                <button className="btn-icon-transparent icon-box" onClick={() => DownloadFile('FileFrontSide')}>
                                                                    <i className="icon-upload-converted"></i>
                                                                </button>
                                                            </div>
                                                            <div className='ar-upload-btn' onClick={() => handleRemoveImage('FileFrontSide')}>
                                                                <i className='icon-delete'></i>
                                                            </div>
                                                            {isPateintImageSaved?.FrontPic ? (
                                                                <div>
                                                                    <i className='bi bi-eye-fill clr-theme fs-18 cursor-pointer' onClick={() => handleShowLivePre('Front')}></i>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='upload-file form-control'>
                                                        <input
                                                            type="file"
                                                            id='FileFrontSide'
                                                            name="FileFrontSide"
                                                            accept=".png, .jpg, .jpeg,"
                                                            onChange={handleImageChange}
                                                        />
                                                        <label htmlFor="FileFrontSide">
                                                            <i className='bi bi-paperclip'></i>
                                                            {mainInsurancePlanModal.FileNameFront ? mainInsurancePlanModal.FileNameFront : "Upload a File"}
                                                        </label>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="mt-2">
                                            <div className="input">
                                                <label>Attach Back Side</label>
                                                {mainInsurancePlanModal.FileNameBack ? (
                                                    <div className='d-flex gap-3 align-items-center mt-1'>
                                                        <p className='heading fst-italic'>{mainInsurancePlanModal.FileNameBack} <span className='ms-1'> 30 KB</span></p>
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <div className="hk-uploadFile__btns m-0">
                                                                <button className="btn-icon-transparent icon-box" onClick={() => DownloadFile('FileBackSide')}>
                                                                    <i className="icon-upload-converted"></i>
                                                                </button>
                                                            </div>
                                                            <div className='ar-upload-btn' onClick={() => handleRemoveImage('FileBackSide')}>
                                                                <i className='icon-delete'></i>
                                                            </div>
                                                            {isPateintImageSaved?.BackPic ? (
                                                                <div>
                                                                    <i className='bi bi-eye-fill clr-theme fs-18 cursor-pointer' onClick={() => handleShowLivePre('Back')}></i>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='upload-file form-control'>
                                                        <input
                                                            type="file"
                                                            id='FileBackSide'
                                                            name="FileBackSide"
                                                            accept=".png, .jpg, .jpeg,"
                                                            onChange={handleImageChange}
                                                        />
                                                        <label htmlFor="FileBackSide">
                                                            <i className='bi bi-paperclip'></i>
                                                            {mainInsurancePlanModal.FileNameBack ? mainInsurancePlanModal.FileNameBack : "Upload a File"}
                                                        </label>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                    </AccordionDetails>
                                </Accordion>

                                {EligibilityBody && (
                                    <div className="hk-eliScreen">
                                        <div className="hk-eliScreen__header">
                                            <p className="heading dark-clr fs-14">Perform Eligibility</p>
                                            <button className="btn-icon-transparent" onClick={() => setEligibilityBody(false)}>
                                                <i className="icon-x-cros fs-20 dark-clr cursor-pointer"></i>
                                            </button>
                                        </div>
                                        <div className="hk-eliScreen__body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className={EligibilityValidationModal.PatientInsuranceIDval ? 'form-group input error' : 'form-group input'}>
                                                        <label htmlFor="SubmissionType">Insurance<span className='text-danger'>*</span></label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='PatientInsuranceID'
                                                            name='PatientInsuranceID'
                                                            searchValue={mainEligibilityModal.PatientInsuranceID}
                                                            data={InsuranceListModal}
                                                            onChange={handleEligibilityChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                            // isReadOnly={isReadOnly}
                                                            inputError={EligibilityValidationModal.PatientInsuranceIDval}
                                                        />
                                                        {EligibilityValidationModal.PatientInsuranceIDval}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className='input form-group'>
                                                        <label htmlFor="SubmissionType">Service Type Code</label>
                                                        <SuperSearchList
                                                            type="client"
                                                            id='ServiceTypeCode'
                                                            name='ServiceTypeCode'
                                                            searchValue={mainEligibilityModal.ServiceTypeCode}
                                                            data={ServiceTypeCode}
                                                            onChange={handleEligibilityChange}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            sup_btn='sup_btn-Inp'
                                                            sup_inp='superSearchVisitInp'
                                                        // isReadOnly={isReadOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className='input form-group'>
                                                        <label htmlFor="SubmissionType">Provider</label>
                                                        <div className='form-group input'>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='ProviderID'
                                                                name='ProviderID'
                                                                searchValue={mainEligibilityModal.ProviderID}
                                                                data={DropDowns?.Provider}
                                                                onChange={handleEligibilityChange}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            // isReadOnly={isReadOnly}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mt-3">
                                                    <div class="form-check custom_check_box   form-check-inline">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            name="UsePracticeNPI"
                                                            id="UsePracticeNPI"
                                                            checked={mainEligibilityModal.UsePracticeNPI}
                                                            onChange={handleEligibilityChange}
                                                        />
                                                        <label class="form-check-label" for="inlineCheckbox2">Use Practice NPI</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="heading ms-4" style={{ color: 'red' }}>{message} &nbsp;
                                            {message === "Receiver Setup Is Not Available for this Patient." ?
                                                <a className='link-btn' onClick={handleOpenInsurance}>Click Here</a> : null
                                            }
                                        </p>
                                        {/* <div className="hk-eliScreen__footer">
                                            <button className="btn btn-orange hk-accordian-btn" onClick={handleSaveEligibility}>
                                                Perform Eligibility
                                            </button>
                                        </div> */}
                                        <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                                            <button className={PerformEligibilityAllowed ? 'btn btn-validate px-10 h-100' : 'btn btn-validate px-10 h-100 disabled'} onClick={handleSaveEligibility}> Perform Eligibility</button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <Modal show={modalActive} onHide={() => setModalActive(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-login-v1 hk-modal-v1 ar_image_modal-new-changes">
                                <Modal.Body>
                                    <div className="d-flex align-items-center justify-content-between gap-20 mb-12">
                                        <p className="heading fs-14 dark-clr validation_message text-nowrap">{prictureData?.type === "Front" ? prictureData?.FileName : prictureData?.type === "Back" ? prictureData?.FileName : ""}</p>
                                        <div className="d-flex align-items-center gap-1">
                                            {/* <IconDownload /> */}
                                            <span onClick={() => DownloadFile(prictureData?.type === 'Front' ? "FileFrontSide" : "FileBackSide")} className='d-flex' >
                                                <IconDownload />
                                            </span>
                                            <i className="icon-x-cros fs-18 dark-clr" onClick={() => setModalActive(false)}></i>
                                        </div>
                                    </div>
                                    <div className="image-box d-flex flex-column align-items-center gap-2">
                                        {mainInsurancePlanModal.FileFrontSideView ? <img src={mainInsurancePlanModal.FileFrontSideView} alt="file front side not available" /> : ''}
                                        {mainInsurancePlanModal.FileBackSideView ? <img src={mainInsurancePlanModal.FileBackSideView} alt="file back side not available" /> : ''}
                                    </div>
                                    {isLoading ? <Loader /> : null}
                                </Modal.Body>
                            </Modal>

                            {/* <div className={showLivePre ? 'filter-panel hk-filter-panel live-preview filter-open' : 'filter-panel live-preview'}>
                                <div className="filter-header">
                                    <p className="heading ">Live Preview</p>
                                    <div className="d-flex gap-10 align-items-center">
                                        <button className="btn-icon-transparent" onClick={() => handleCloseLivePre()}><i className="icon-Icon-metro-cross"></i></button>
                                    </div>
                                </div>
                                <div className="filter-body">
                                    <div>
                                        <div className='preview-img front'>
                                            {mainInsurancePlanModal.FileFrontSideView ? <img src={mainInsurancePlanModal.FileFrontSideView} alt="file front side not available" /> : ''}
                                        </div>
                                        <p className="text mt-2 fs-12 text-center">front</p>
                                    </div>
                                    <div className='mt-4'>
                                        <div className='preview-img back'>
                                            {mainInsurancePlanModal.FileBackSideView ? <img src={mainInsurancePlanModal.FileBackSideView} alt="file back side not available" /> : ''}
                                        </div>
                                        <p className="text mt-2 fs-12 text-center">back</p>
                                    </div>
                                </div>

                            </div> */}
                        </div>
                    </div>
                </div>
                {isOpenMissing &&
                    <div className='missing_detail'>
                        <div className='demo missing_data'>
                            <span className='d-flex align-items-center'>
                                <span class="icon-Group-4785"><span class="path1 fs-18"></span><span class="path2 "></span><span class="path3 "></span></span>
                                Insurance have some data missing <span className='detail border-0'><i className=' cursor-pointer ms-5 icon-Icon-metro-cross' onClick={() => setIsOpenMissing(false)}></i></span>
                            </span>
                            <div className='message_list'>
                                {missingDataInfo.map((item) => {
                                    return (
                                        <p className='text'>{item}</p>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                }
                <div className='tabs-action-bottom br-top-1 br-clr justify-content-between d-flex position-static br-bottom-1'>
                    <div className='col-md-3'>
                        <div className='m-2'>
                            <p className='heading heading_ext'>Updated By/Date: <br /> <span className='text text_color'>{!isNull(mainInsurancePlanModal.CreatedBy) ? mainInsurancePlanModal.CreatedBy + ', ' + mainInsurancePlanModal.CreatedDate : 'N/A'}</span></p>
                        </div>
                    </div>
                    <div className='col-md-3 mt-2' style={{ margin: "0 200px 0 0" }}>
                        <div className="mt-1 position-relative">
                            {InsuranceID > 0 ? <>
                                {isNull(mainInsurancePlanModal.ErrorMessages) ?
                                    <div className='demo'>
                                        <span > <i className='icon-check-circle'></i> Insurance have no missing data</span>
                                    </div>
                                    :
                                    <div className='demo missing_data'>
                                        <span className='d-flex align-items-center'>
                                            <span class="icon-Group-4785"><span class="path1 fs-18"></span><span class="path2 "></span><span class="path3 "></span></span>
                                            Insurances have some data missing <span className='detail cursor-pointer' onClick={handleOpenMissingData}><i className='icon-arrow-right2'></i></span>
                                        </span>
                                    </div>
                                }
                            </> : null}
                        </div>
                    </div>
                    <div className='btns-group text-end px-3  d-flex align-items-center justify-content-end py-2'>
                        <button className={IsEditAllowed ? 'btn btn-orange m-0' : 'btn btn-orange m-0 disabled'} onClick={handleSaveInsurancePlan}>Save</button>
                    </div>
                </div>
            </div>
            <Modal show={EligibilityPopup} onHide={CloseEligibilityPopup} backdrop="static" keyboard={false} centered className='app-modal modal modal-dialog-centered modal-lg add_new_eligibility hk-modal-v1'>
                <Modal.Body className='pb-4'>
                    <div className='d-flex justify-content-end' onClick={() => setEligibilityPopup(false)}>
                        <button className="btn-icon-transparent">
                            <i className="icon-Icon-metro-cross"></i>
                        </button>
                    </div>
                    <EligiblityHistoryStatus type={'PlanInfo'} id={EligibilityID} />
                </Modal.Body>
            </Modal>
            <Modal show={updateAlertPopup} onHide={updateAlertPopup} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 za-exit-group za-update-subscriber-id">
                <Modal.Body>
                    {/* {isIDsUpdated?.SbrIDUpdated ?  */}
                    <div className='paragraph d-flex gap-1'>
                        <i className='icon-Vector13 fs-16'></i>
                        <p className=' text fs-12 fst-italic'>
                            You have {claimsCount} visits associated with the previous information.
                            Do you want to update with latest information for these visits as well?
                            {/* You have {SbrClaimsCount} visits associated with the previous Subscriber # [{previousSubscriberID}]. Do you want to update the Subscriber # [{NewSubscriberID}] for these visits as well? */}
                        </p>
                    </div>
                    {/*  : <></>} */}
                    {/* {isIDsUpdated?.InsIDUpdated ? <div className='paragraph d-flex gap-1'>
                        <i className='icon-Vector13 fs-16'></i>
                        <p className=' text fs-12 fst-italic'>You have {InsClaimsCount} visits associated with the previous Insurance # [{previousInsuranceID}]. Do you want to update the Insurance # [{NewInsuranceID}] for these visits as well?</p>
                    </div> : <></>} */}
                    <div className='za-button text-end'>
                        <button className='btn btn-cancel heading fs-12 px-10' onClick={handleSubscriberClose}> No</button>
                        <button className='btn btn-exit heading fs-12 px-10' onClick={handleSubscriber}> Yes</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
export default PlanIformation